export const backendURL = 'https://api.marketplace.thinkboxsoftware.com';

export const collectionsURL = 'https://thinkbox-marketplace-v2-inventory.s3.amazonaws.com/collections-latest.json';

export const productsURL = 'https://thinkbox-marketplace-v2-inventory.s3.amazonaws.com/products-latest.json';
